import { useState, useEffect, useRef } from "react";

// classes
import Aircraft from "classes/aircraft";

//css
import "./ChangeRegistration.scoped.scss";

const ChangeRegistration = ({ aircraft, center = false, title = "", style = {} }) => {
	const [reg, setReg] = useState(aircraft?.registration || "XX-(X)XXX");

	//references
	const cogRef = useRef();
	const inputRef = useRef();
	const registrationRef = useRef();
	const checkRef = useRef();
	const crossRef = useRef();

	const showChangeRegistrationField = e => {
		cogRef.current.classList.add("hide");
		inputRef.current.classList.remove("hidden");
		registrationRef.current.classList.add("hide");
		checkRef.current.classList.remove("hide");
		crossRef.current.classList.remove("hide");
		e.stopPropagation();
	};

	const hideChangeRegistrationField = () => {
		inputRef.current.classList.add("hidden");
		registrationRef.current.classList.remove("hide");
		checkRef.current.classList.add("hide");
		crossRef.current.classList.add("hide");
		setTimeout(() => cogRef.current?.classList.remove("hide"), 100);
	};

	const changeRegistration = e => {
		e.stopPropagation();

		aircraft.registration = reg.toUpperCase();
		aircraft.updateInRedux();
		Aircraft.saveFleet();

		hideChangeRegistrationField();
	};

	const cancel = e => {
		setReg(aircraft?.registration || "XX-(X)XXX");
		hideChangeRegistrationField();
		e.stopPropagation();
	};

	useEffect(() => {
		if (!aircraft?.registration) return;
		if (aircraft.registration !== reg && reg !== "XX-(X)XXX") return;
		setReg(aircraft.registration);
	}, [aircraft, reg]);

	return (
		<div className={`registration ${center && "registration--center"}`} title={title} style={style}>
			<input
				type="text"
				className="registration__input hidden"
				value={reg}
				onClick={e => e.stopPropagation()}
				onChange={e => setReg(e.target.value)}
				ref={inputRef}
			/>
			<span ref={registrationRef}>{reg}</span>
			<i className="fas fa-cog" ref={cogRef} onClick={showChangeRegistrationField} />
			<i className="fas fa-check hide" ref={checkRef} onClick={changeRegistration} />
			<i className="fas fa-times hide" ref={crossRef} onClick={cancel} />
		</div>
	);
};

export default ChangeRegistration;
